import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=4d059bfa&scoped=true"
import script from "./safe.vue?vue&type=script&lang=js"
export * from "./safe.vue?vue&type=script&lang=js"
import style0 from "./safe.vue?vue&type=style&index=0&id=4d059bfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d059bfa",
  null
  
)

export default component.exports